import * as React from "react"
import {useState} from "react"
import {Button, Collapse} from "react-bootstrap";
import {FaComment} from "react-icons/fa";
import {CommentModel} from "../../../models/domain/commentModel";
import {catalogName} from "../../../utils/helpers";

interface IProps {
    ratingId: number | string
    comments: CommentModel[]
}

export const Comments = ({ratingId, comments}: IProps) => {
    const [open, setOpen] = useState<boolean>(false);
    
    return (
        <>
            <Button
                variant="link"
                onClick={() => setOpen(!open)}
                aria-controls={`comments-${ratingId}`}
                aria-expanded={open}
            >
                <FaComment className="me-1"/>
                See {catalogName}'s Response{comments.length > 1 && 's'}
            </Button>
            <Collapse in={open} className="bg-light text-start">
                <div id={`comment-${ratingId}`}>
                    {comments.map(({id, text, byline}) => (
                        <div key={id} className="comment p-3 border-bottom">
                            {text}
                            <small className="text-muted d-block mt-1">
                                {byline}
                            </small>
                        </div>
                    ))}
                </div>
            </Collapse>
        </>
    )
}